import { gql } from '@apollo/client';
import COMPONENT_COLORS_AND_SIZES from '../fragments/COMPONENT_COLORS_AND_SIZES';
const SET_COMPONENT_HAS_ONE_VARIANT_SIZE_FOR_ALL_SPECIFICATION_SIZES = gql `
  ${COMPONENT_COLORS_AND_SIZES}
  mutation ToggleVariedOnSize(
    $componentId: ID!
    $hasOneVariantSizeForAllSpecificationSizes: Boolean!
  ) {
    setComponentHasOneVariantSizeForAllSpecificationSizes(
      componentId: $componentId
      hasOneVariantSizeForAllSpecificationSizes: $hasOneVariantSizeForAllSpecificationSizes
    ) {
      component {
        id
        hasOneVariantSizeForAllSpecificationSizes
        variantSizeForAllSpecificationSizes
        productSnapshot {
          id
          product {
            id
            name
            componentSize {
              id
              name
            }
          }
        }
        ...ComponentColorsAndSizesFragment
      }
    }
  }
`;
export default SET_COMPONENT_HAS_ONE_VARIANT_SIZE_FOR_ALL_SPECIFICATION_SIZES;
